module.exports = __webpack_public_path__ + "assets/Girder_Mark-6719b633.png";


//////////////////
// WEBPACK FOOTER
// ./clients/web/src/assets/Girder_Mark.png
// module id = 274
// module chunks = 0